/// <reference path="../../../../../../typings/index.d.ts" />
/// <reference path="../../basicEmailMarketing.module.ts" />

module Meevo.Plugins.BasicEmailMarketing {

    interface IItemCriteria {
        excludeIdList?: string[];
        serviceCategoryId?: string;
        productCategoryId?: string;
        includeBundles?: boolean;
        includeInactive?: boolean;
        includeDiscontinuedProducts?: boolean;
        variantObjectState?: any;
    }

    class CategoryAndItemComponent implements ng.IComponentController {
        static $inject = [
            '$scope',
            '$translate'
        ];

        //#region bindings
        public template: 'product' | 'service';
        public categoryModel: Model.ServiceCategory | Model.ProductCategory;
        public itemModel: Model.Service | Model.Product;
        public excludeItems: string[];
        public anyItem: boolean;
        public anyCategory: boolean;
        public onChange: () => {};
        public disabled: boolean;
        public includeInactiveServices: boolean;
        public includeDiscontinuedProducts: boolean;
        //#endregion bindings

        public AnyActiveService: Model.Service = {
            id: null,
            displayName: this.$translate.instant('LABEL_ANY_ACTIVE_SERVICE')
        }

        public AnyActiveServiceCategory: Model.ServiceCategory = {
            id: null,
            displayName: this.$translate.instant('LABEL_ANY_ACTIVE_SERVICE_CATEGORY')
        };

        public AnyService: Model.ServiceCategory = {
            id: null,
            displayName: this.$translate.instant('LABEL_ANY_SERVICE')
        };

        public AnyServiceCategory: Model.ServiceCategory = {
            id: null,
            displayName: this.$translate.instant('LABEL_ANY_SERVICE_CATEGORY')
        };

        public AnyProduct: Model.Product = {
            id: null,
            displayName: this.$translate.instant('LABEL_ANY_PRODUCT')
        };

        public AnyProductCategory: Model.ProductCategory = {
            id: null,
            displayName: this.$translate.instant('LABEL_ANY_PRODUCT_CATEGORY')
        }

        public AnyActiveProduct: Model.Product = {
            id: null,
            displayName: this.$translate.instant('LABEL_ANY_NOT_DISCONTINUED_PRODUCT')
        }

        public categoryCriteria: IItemCriteria = {};
        public itemCriteria: IItemCriteria = {};

        constructor(
            protected $scope: ng.IScope,
            protected $translate: angular.translate.ITranslateService
        ) {
            this.setWatchers();
        }

        public categoryChanged(): void {
            switch (this.template) {
                case 'service':
                    this.itemCriteria.serviceCategoryId = (this.categoryModel && this.categoryModel.id) ? this.categoryModel.id : null;
                    break;
                case 'product':
                    this.itemCriteria.productCategoryId = (this.categoryModel && this.categoryModel.id) ? this.categoryModel.id : null;
                    break;
            }
        }

        public typeAheadPreProcessData(responseData, requestData, type: 'category' | 'item', includeInactive: boolean, includeDiscontinuedProducts: boolean): any[] {
            if (requestData.pageNumber !== 0) {
                return responseData;
            }
            if (type === 'category' && this.anyCategory) {
                switch (this.template) {
                    case 'service':
                        responseData.splice(0, 0, includeInactive ? this.AnyServiceCategory : this.AnyActiveServiceCategory)
                        break;
                    case 'product':
                        responseData.splice(0, 0, this.AnyProductCategory)
                        break;
                }
            }

            if (type === 'item' && this.anyItem) {
                switch (this.template) {
                    case 'service':
                        responseData.splice(0, 0, includeInactive ? this.AnyService : this.AnyActiveService)
                        break;
                    case 'product':
                        responseData.splice(0, 0, includeDiscontinuedProducts ? this.AnyProduct : this.AnyActiveProduct)
                        break;
                }
            }

            return responseData;
        }

        private setWatchers(): void {
            this.$scope.$watch(() => this.template, (newValue) => {
                this.categoryCriteria = {};
                this.itemCriteria = { excludeIdList: this.excludeItems || [] };
                if (this.template == 'product') {
                    this.itemCriteria.includeBundles = true;
                }
            });
            this.$scope.$watch(() => this.excludeItems, (newValue) => {
                this.itemCriteria.excludeIdList = this.excludeItems || [];
                if (this.template != null && this.template == 'product') {
                    this.itemCriteria.includeBundles = true;
                }
            });
            this.$scope.$watch(() => this.includeInactiveServices, () => {
                if (this.template != null && this.template == 'service') {
                    this.categoryCriteria = { includeInactive: this.includeInactiveServices };
                    this.itemCriteria = { includeInactive: this.includeInactiveServices };
                    this.categoryModel = this.includeInactiveServices ? this.AnyServiceCategory : this.AnyActiveServiceCategory;
                    this.itemModel = this.includeInactiveServices ? this.AnyService : this.AnyActiveService;
                } else {
                    return
                }
            });
            this.$scope.$watch(() => this.includeDiscontinuedProducts, () => {
                if (this.template != null && this.template == 'product') {
                    this.categoryCriteria = {
                        includeInactive: this.includeDiscontinuedProducts,
                        includeDiscontinuedProducts: this.includeDiscontinuedProducts,
                        variantObjectState: this.includeDiscontinuedProducts ? [2026, 2027] : [2026]
                    };
                    this.itemCriteria = {
                        includeInactive: this.includeDiscontinuedProducts,
                        includeDiscontinuedProducts: this.includeDiscontinuedProducts,
                        variantObjectState: this.includeDiscontinuedProducts ? [2026, 2027] : [2026]
                    };

                    if (this.anyCategory) {
                        this.categoryModel = this.AnyProductCategory;
                    }

                    if (this.anyItem) {
                        this.itemModel = this.includeDiscontinuedProducts ? this.AnyProduct : this.AnyActiveProduct;
                    }
                } else {
                    return
                }
            });
        }
    }

    angular.module('meevo.plugins.basicEmailMarketing')
        .component('meevoCategoryAndItem', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/basicEmailMarketing/components/category-and-item/category-and-item.template.html',
            controller: CategoryAndItemComponent,
            controllerAs: '$ctrl',
            bindings: {
                template: '=',
                categoryModel: '=',
                itemModel: '=',
                excludeItems: '=',
                anyItem: '=',
                anyCategory: '=',
                onChange: '&',
                disabled: '=?ngDisabled',
                includeInactiveServices: '=',
                includeDiscontinuedProducts: '='
            }
        });
}
